module.exports = __webpack_public_path__ + "static/media/CompanyProfilemap@3x.d10e8ccc.png";